import { isNil, isString } from 'lodash-es';

interface ICache {
    readonly length: number;
    clear(): void;
    getItem<T = unknown>(key: string): T | null;
    getItem<T = string>(key: string): string | null;
    key(index: number): string | null;
    removeItem(key: string): void;
    setItem<T = unknown>(key: string, value: T): void;
    setItem(key: string, value: string): void;
}

class LocalStorageCache implements ICache {
    static create() {
        return new LocalStorageCache();
    }

    get length() {
        return localStorage.length;
    }

    clear() {
        return localStorage.clear();
    }

    getItem<T = unknown>(key: string) {
        const value = localStorage.getItem(key);
        if (isNil(value)) {
            return null;
        }

        try {
            return JSON.parse(value) as T;
        } catch (/* SyntaxError, not valid JSON*/ error) {
            return value;
        }
    }

    key(index: number) {
        return localStorage.key(index);
    }

    removeItem(key: string) {
        return localStorage.removeItem(key);
    }

    setItem<T = unknown>(k: string, v: T) {
        if (isNil(v)) {
            return;
        }

        return localStorage.setItem(k, isString(v) ? v : JSON.stringify(v));
    }
}

const CK_CUSTOMER_ACCOUNT = 'CustomerAccount';
const CK_BILL_TO_ID = 'BillToId';
const CK_USER_ID = 'UserID';
const CK_USER_TOKEN = 'UserToken';
const CK_DEBT_EMAIL = 'BNPDebtEmail';

export {
    ICache,
    CK_BILL_TO_ID,
    CK_CUSTOMER_ACCOUNT,
    CK_DEBT_EMAIL,
    CK_USER_ID,
    CK_USER_TOKEN,
    LocalStorageCache,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/cache.ts